import React, { useEffect, useState } from 'react'
import RequiredInfo from './RequiredInfo'
import StepperContentList from './StepperContentList';
import CreatedMessageStepper from './CreatedMessageStepper';
import ClosedCaseStepper from './ClosedCaseStepper';
import ProfessionalDetailsSubModal from 'Modals/ProfessionalDetailsSubModal';
import ProfessionalDetailsModal from 'Modals/ProfessionalDetailsModal';

function StepperContent({contentStep, caseDetails, setUpdateComp, requestPopupRef}) {
  const getTeamupInfo = (fromUser, toUser) => {
    if (toUser?.isUserFunder) { //toUser is a funder.
      return fromUser?.firstName + " " + fromUser?.lastName + " and " + toUser?.company + " ";
    } else if (fromUser?.isUserFunder) {
      return toUser?.firstName + " " + toUser?.lastName + " and " + fromUser?.company + " ";
    } else {
      return fromUser?.firstName + " " + fromUser?.lastName + " and " + toUser?.firstName + " " + toUser?.lastName + " ";
    }
  }
  const builder = (step) => {
    switch(step) {
        case 2:
          case 3:
            case 4:
        return <><StepperContentList
        contentStep={contentStep}
        caseDetails={caseDetails}
        setUpdateComp={setUpdateComp}
        requestPopupRef = {requestPopupRef}

        /></>
        case 5: 
        return <div className='w-full flex items-center justify-center'> 
              {
                caseDetails?.userCase?.["reqToClose"]?.[0] ?
                <div className='w-[90%]   flex flex-col'>
                  
                    {
                      caseDetails?.userCase?.["reqToClose"]?.[0]?.teamup && caseDetails?.userCase?.["reqToClose"]?.[0]?.teamup?.fromUser ?
                      <div>
                        <div className='flex justify-center w-full font-bold px-4 pt-2 text-sm lg:text-base lg:mt-6 lg:mb-6'>
                          {getTeamupInfo(caseDetails?.userCase?.["reqToClose"]?.[0]?.teamup?.fromUser, caseDetails?.userCase?.["reqToClose"]?.[0]?.teamup?.toUser)}
                          teamed up to close this case.
                        </div>
                          <ProfessionalDetailsSubModal
                        professionalDetails={caseDetails?.userCase?.["reqToClose"]?.[0]} 
                        contentStep={contentStep}
                        setUpdateComp={setUpdateComp}
                        showTeamupDetails = {true}
                        caseDetails={caseDetails}
                        />
                        

                      </div>

                    :
                    <ProfessionalDetailsSubModal 
                        professionalDetails={caseDetails?.userCase?.["reqToClose"]?.[0]} 
                        contentStep={contentStep}
                        setUpdateComp={setUpdateComp}
                        caseDetails={caseDetails}
                      />
                    }
                  </div>
                  :
                  <div>No entries found</div>
              }
                  </div>
        case 6: 
        
          // closed: hero + download + who they closed it with (teamup line is inside)
          return <div className='w-full px-4 lg:px-8'>
              {
                caseDetails?.userCase?.["closed"]?.[0] ?
                <ClosedCaseStepper profDetails={caseDetails?.userCase?.["closed"]?.[0]} caseDetails={caseDetails} />
                :
                <div className='py-6 text-center text-[13.5px] text-[rgba(20,33,61,.6)] font-plexsans'>No entries found</div>
              }
                  </div>
        default:
            <></>
    }
  }
  return (
    <>
      { contentStep !== 1 &&
        <div className='w-full flex transition-all '>
          <div className='bg-cream lg:bg-gray-50 lg:border-t border-[rgba(20,33,61,.1)] w-full'>
             {builder(contentStep)}
          </div>
      </div>
      }
    </>
    
   
  )
}

export default StepperContent